import chunk from 'lodash/chunk';
import React, { Fragment } from 'react';
import { FontIcon } from '../../components/FontIcon';
import { Column } from '../../components/Grid';
import { HtmlContent } from '../../components/layout/HtmlContent';
import {
  NavigationLink,
  NavigationList,
  NavigationListItem
} from '../../components/Navigation';
import { MenuEntry } from '../../provider/Typo3Provider/types';

interface MenuEntryColumnsProps {
  children: MenuEntry[];
  entriesPerColumn: number;
}

const FontIconLink = FontIcon.withComponent(NavigationLink);

const MenuEntryColumns = ({
  children,
  entriesPerColumn
}: MenuEntryColumnsProps) => {
  const columns = chunk(children, entriesPerColumn);
  const numColumns = columns.length;
  return (
    <Fragment>
      {columns.map((entries, index) => (
        <Column key={index} large={12 / numColumns}>
          <NavigationList>
            {entries.map((entry, index) => (
              <NavigationListItem key={index}>
                <FontIconLink to={entry.link} icon="arrow" arrow="right">
                  <HtmlContent htmlString={entry.title} />
                </FontIconLink>
              </NavigationListItem>
            ))}
          </NavigationList>
        </Column>
      ))}
    </Fragment>
  );
};

export default MenuEntryColumns;
